import { Axios } from "axios";
import { RequestApiRouteConfig, getRequestBasePath } from "../Api/routeConfig";
import { RequestFileDto } from "../Schemas/RequestFileDto";

const buildStreamFileUrl = (
    requestModuleUrl: string,
    fileId: string,
    routeConfig?: RequestApiRouteConfig,
    download?: boolean
): string => {
    const requestBasePath = getRequestBasePath(routeConfig);
    const baseUrl = `${requestModuleUrl}/${requestBasePath}/streamfile?id=${fileId}`;
    return download ? `${baseUrl}&download=true` : baseUrl;
};

export async function downloadStreamFile(
    axiosInstance: Axios,
    requestModuleUrl: string,
    file: RequestFileDto,
    routeConfig?: RequestApiRouteConfig
): Promise<void> {
    if (!file.id) return;
    const url = buildStreamFileUrl(requestModuleUrl, file.id, routeConfig, true);
    const response = await axiosInstance.get(url, { responseType: "blob" });
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = file.name || "file";
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
}

export async function openPdfInNewTab(
    axiosInstance: Axios,
    requestModuleUrl: string,
    file: RequestFileDto,
    routeConfig?: RequestApiRouteConfig
): Promise<void> {
    if (!file.id) return;
    const url = buildStreamFileUrl(requestModuleUrl, file.id, routeConfig);
    const response = await axiosInstance.get(url, { responseType: "blob" });
    const blob = new Blob([response.data], { type: response.headers["content-type"] || "application/pdf" });
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 120_000);
}
